import { render } from "./Tickets.vue?vue&type=template&id=a355e8b8&scoped=true"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=a355e8b8&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Tracker Eticket\\Tracker_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a355e8b8"]])

export default __exports__